import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/inspospotr-casebg@2x-min.jpg';

export default {
  key: 'inspospotr',
  path: '/cases/inspospotr',
  color: variables.inspospotr,
  title: 'Inspospotr',
  casebg,
  description: 'Assisted Online Shopping',
  headline: 'Web app & Facebook application',
  isWeb: false,
  isAndroid: false,
};
